// import React, { useState } from 'react';
// import '../styles/FAQ.css';

// const FAQ = () => {
//   const [activeIndex, setActiveIndex] = useState(null);

//   const faqs = [
//     {
//       question: "What is solar energy and how does it work?",
//       answer: "Solar energy is radiant light and heat from the sun that is harnessed using a range of ever-evolving technologies such as solar heating, photovoltaics, solar thermal energy, solar architecture, molten salt power plants and artificial photosynthesis."
//     },
//     {
//       question: "How much can I save with solar panels?",
//       answer: "Savings from solar panels vary based on your location, energy consumption, and local electricity rates. On average, homeowners can save between 40-60% on their electricity bills, with payback periods typically ranging from 5-7 years."
//     },
//     {
//       question: "What are the different types of solar panels?",
//       answer: "The main types of solar panels are monocrystalline, polycrystalline, and thin-film. Monocrystalline panels are the most efficient and expensive, while polycrystalline offer good efficiency at a lower cost. Thin-film panels are flexible but less efficient."
//     },
//     {
//       question: "How long do solar panels last?",
//       answer: "Most solar panels come with a 25-year warranty and can last 30-40 years with proper maintenance. They typically degrade at a rate of about 0.5% per year, meaning they'll still produce about 80-90% of their original output after 25 years."
//     },
//     {
//       question: "What maintenance do solar panels require?",
//       answer: "Solar panels require minimal maintenance. Regular cleaning to remove dust and debris, annual inspections to check for damage, and monitoring system performance are typically sufficient. Most systems don't require any moving parts maintenance."
//     },
//     {
//       question: "Can I install solar panels myself?",
//       answer: "While DIY installation is possible, it's not recommended for most homeowners. Professional installation ensures safety, proper wiring, compliance with local codes, and eligibility for warranties and incentives."
//     },
//     {
//       question: "What happens during power outages?",
//       answer: "Standard grid-tied solar systems shut down during power outages for safety reasons. However, with battery storage or a hybrid inverter, you can have backup power during outages while still being connected to the grid."
//     },
//     {
//       question: "Are there government incentives for solar?",
//       answer: "Yes, there are various government incentives including tax credits, rebates, and net metering programs. The PM Surya Ghar Yojana and other state-specific schemes can significantly reduce the upfront cost of solar installation."
//     }
//   ];

//   const toggleFAQ = (index) => {
//     setActiveIndex(activeIndex === index ? null : index);
//   };

//   return (
//     <section className="faq-section">
//       <div className="faq-container">
//         <div className="faq-header">
//           <h2 style={{ borderBottom: '3px solid #2E8B57', display: 'inline-block' }}>Frequently Asked Questions</h2>
//           <p>Everything you need to know about solar energy</p>
//         </div>
        
//         <div className="faq-list">
//           {faqs.map((faq, index) => (
//             <div 
//               key={index} 
//               className={`faq-item ${activeIndex === index ? 'active' : ''}`}
//               onClick={() => toggleFAQ(index)}
//             >
//               <div className="faq-question">
//                 <h3>{faq.question}</h3>
//                 <div className="faq-toggle">
//                   <span className="faq-icon">+</span>
//                 </div>
//               </div>
//               <div className="faq-answer">
//                 <p>{faq.answer}</p>
//               </div>
//             </div>
//           ))}
//         </div>
        
//         <div className="faq-footer">
//           <h3>Still have questions?</h3>
//           <p>Our solar experts are here to help you make the right choice</p>
//           <div className="faq-actions">
//             <button className="primary-btn">Schedule Consultation</button>
//             <button className="secondary-btn">Download Guide</button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FAQ;

import React, { useState } from 'react';
import '../styles/FAQ.css';

const FAQ = ({ faqs, title = "Frequently Asked Questions", subtitle }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-container">

        <div className="faq-header">
          <h2 style={{ borderBottom: '3px solid #2E8B57', display: 'inline-block' }}>
            {title}
          </h2>
          {subtitle && <p>{subtitle}</p>}
        </div>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <h3>{faq.question}</h3>
                <div className="faq-toggle">
                  <span className="faq-icon">+</span>
                </div>
              </div>

              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FAQ;
